import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { translate } from 'react-jhipster';
import { stringify } from 'querystring';

export const SelectFeautureItem = props => {
  const [selected, setSelected] = useState(false);

  const handleSelectClick = e => {
    props.onClick({
      price: props.data.price,
      element: props.element,
      duration: props.data.duration,
      selected: !selected,
    });
    setSelected(!selected);
  };

  useEffect(() => {
    // console.warn(props.setAvailable);
    // console.warn(Object
    //     .keys(props.setAvailable));

    if (props.setAvailable !== undefined && props.setAvailable[0] !== undefined && props.setAvailable[0]['feature'] !== undefined) {
      const val = props.setAvailable[0]['feature'].filter(element => element.element === props.element).length > 0;
      setSelected(val);
      if (val) handleSelectClick(1);
    }
  }, []);

  console.warn(props.setAvailable);
  return (
    <Row className={`selectable-row ${selected ? 'selected' : ''}`} onClick={handleSelectClick}>
      <Col>
        <Row className="align-items-center">
          <Col xs="auto">
            <img src={props.data.image} alt={props.element} className="selectable-row-img" />
          </Col>
          <Col className="selectable-row-title">{props.element}</Col>
          <Col className="selectable-row-price">${props.data.price}</Col>
        </Row>

        <Row>
          <Col className="selectable-row-desc">{translate('project.wizard.' + props.data.datalang)}</Col>
        </Row>
      </Col>
    </Row>

    // <Button {...this.props}   />
  );
};
